import { InfoTooltip } from 'components/shared/InfoTooltip';
import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import { FC, useMemo } from 'react';
import { useIntl } from 'react-intl';

export interface BatchFieldNameCellProps {
  className?: string;
  tooltipTranslationKey?: IntlKey;
  fieldNameTranslationKey: IntlKey;
  id: string;
}

// TODO: batch screen unit test
export const BatchFieldNameCell: FC<BatchFieldNameCellProps> = ({
  tooltipTranslationKey,
  fieldNameTranslationKey,
  className,
  id,
}) => {
  const { formatMessage } = useIntl();

  const shouldDisplayTooltip = useMemo(() => {
    if (tooltipTranslationKey === undefined) {
      return false;
    }
    const label = formatMessage({ id: tooltipTranslationKey, defaultMessage: tooltipTranslationKey });
    return label !== tooltipTranslationKey;
  }, [formatMessage, tooltipTranslationKey]);

  return (
    <div className={className}>
      <div className="d-flex justify-content-end align-items-center bg-lvl2 pe-2 fw-normal fs-6 h-100 gap-2">
        <div className="text-wrap text-truncate text-end fs-6">
          {shouldDisplayTooltip && (
            <InfoTooltip className="pe-2" id={`tooltip-${id}`} tooltipKey={tooltipTranslationKey} />
          )}
          <FormattedMessage id={fieldNameTranslationKey as any} />
        </div>
      </div>
    </div>
  );
};
